import { css } from '@emotion/css';
import { minScreen } from 'utils/mediaQueries';
import { Color } from 'utils/variables';
import { buttonInteraction } from 'utils/mixin';

export const body = css(
  buttonInteraction,
  css`
  background: linear-gradient(125.6deg, #F3696E 12.73%, #F8A902 100%);
  border-radius: 20px;
  box-shadow: 0px 6px 10px rgba(217, 91, 0, 0.25);
  box-sizing: border-box;
  color: ${Color.White};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  ${minScreen('md')} {
    height: 50px;
  }
`
);

export const large = css`
  width: 100%;
  max-width: 290px;
  height: 60px;
  ${minScreen('md')} {
    width: 290px;
    max-width: none;
  }
`;
export const medium = css`
  width: 100%;
  max-width: 255px;
  height: 50px;
  ${minScreen('md')} {
    width: 260px;
    max-width: none;
  }
`;
export const disabled = css`
  opacity: 0.5;
  pointer-events: none;
`;
export const arrow = css`
  position: relative;
  &::after {
    width: 9px;
    height: 9px;
    position: absolute;
    top: 50%;
    right: 20px;
    content: '';
    border-top: solid 2px ${Color.White};
    border-right: solid 2px ${Color.White};
    transform: translateY(-50%)rotate(45deg);
  }
`;